import React from 'react';
import CTALink from '../../components/buttons/CTALink';
import { TDR } from 'tdr-common';
import { useTranslation } from 'react-i18next';

export const InternalErrorToast = () => {
	const { t } = useTranslation();
	return (
		<>
			<p>{t('error_pages.unexpected_body')}</p>
			<CTALink text={t('actions.get_help')} to={`mailto:${TDR.SUPPORT_EMAIL}`} variant='dark' />
		</>
	);
};
